<div class="container-fluid page">
  <!-- <button mat-raised-button (click)="openDialog()">Pick city or food</button> -->
  <div class="d-flex page__box p-3 mt-2">
    &nbsp;&nbsp; Banner Management In Mobile App
  </div>
  <div class="page__content shadow p-3">
    <form [formGroup]="bannerForm" (ngSubmit)="onSubmit()">
      <div class="row card" *ngFor="let item of formList; index as i">
        <mat-card style="margin-bottom: 10px">
          <div class="row card-header">
            <div class="col-sm-9">
              <label for="file" style="font-size: 20px"
                >Banner {{ i + 1 }}</label
              >
            </div>
            <div class="col-sm-3" *ngIf="item">
              <div style="margin-left: 80%">
                <mat-icon style="cursor: pointer; color: #185494" (click)="deleteBanner(i + 1)"
                  >delete</mat-icon
                >
              </div>
            </div>
          </div>

          <div class="row card-body">
            <div class="col-sm-9">
              <div class="bannerArea">
                <input
                  type="radio"
                  class="bannerRadio"
                  value="1"
                  [name]="'banner' + i"
                  [id]="'imageRadio' + (i + 1)"
                  (change)="bannerCheck(i + 1)"
                />

                <div class="form-group col-sm-11">
                  <label [for]="link" style="font-size: 17px"
                    >Upload a local image from your PC</label
                  >
                  <input
                    type="file"
                    [name]="'image' + i"
                    [id]="'image' + (i + 1)"
                    accept="image/*"
                    class="form-control"
                    (change)="uploadFile($event, i)"
                  />
                </div>
              </div>

              <div class="bannerArea">
                <input
                  class="bannerRadio"
                  type="radio"
                  value="2"
                  [name]="'banner' + i"
                  [id]="'linkRadio' + (i + 1)"
                  (change)="bannerCheck(i + 1)"
                />
                <div class="form-group col-sm-11">
                  <label [for]="link" style="font-size: 17px"
                    >Online Image</label
                  >
                  <input
                    id="link"
                    [name]="'link' + i"
                    [id]="'link' + (i + 1)"
                    type="text"
                    formControlName="link"
                    class="form-control"
                    placeholder="Paste the image URL below"
                    (input)="link($event, i)"
                  />
                </div>
              </div>

              <!--  URL  -->
              <div class="bannerArea">
                <!-- <input
                  class="bannerRadio"
                  type="radio"
                  value="2"
                  [name]="'banner' + i"
                  [id]="'linkRadio' + (i + 1)"
                  (change)="bannerCheck(i + 1)"
                /> -->
                <div class="form-group col-sm-11 alignment">
                  <label [for]="link" style="font-size: 17px"
                    >Redirection URL</label
                  >
                  <input
                    id="url"
                    [name]="'url' + i"
                    [id]="'url' + (i + 1)"
                    type="text"
                    formControlName="url"
                    class="form-control"
                    placeholder="Paste the redirection URL below"
                    (input)="redirectUrl($event, i)"
                  />
                </div>
              </div>
              <!--  -->
            </div>
            <div class="col-sm-3 d-flex justify-content-center align-items-center">
              <img
                [id]="'bannerImage' + (i + 1)"
                [src]="imageURL[i] ? imageURL[i] : item"
                class="img-thumbnail"
                width="304"
                height="200"
              />
            </div>
          </div>
        </mat-card>
      </div>
      <div class="btnArea">
        <button
          mat-raised-button
          type="button"
          class="output-button"
          (click)="refreshForm()"
        >
          Cancel
        </button>
        <button mat-button type="submit" class="output-button">Update</button>
      </div>
    </form>
  </div>
</div>
